var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isModalVisible,
          expression: "isModalVisible"
        }
      ]
    },
    [
      _c("div", { staticClass: "modal-mask", on: { click: _vm.closeModal } }, [
        _c(
          "div",
          {
            staticClass: "modal-container",
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c("div", { staticClass: "modal-header" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: { click: _vm.closeModal }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.loading,
                    expression: "!loading"
                  }
                ],
                staticClass: "modal-body"
              },
              [
                _c("div", { staticClass: "col-8 override-padding" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-lg-4 float-left padding-lr-5",
                      staticStyle: { "padding-left": "0" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.edit_assessment_section_title,
                            expression: "edit_assessment_section_title"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass:
                          "col-lg-12 padding-lr-5 input-text form-control",
                        staticStyle: {
                          "line-height": "30px",
                          "margin-right": "10px"
                        },
                        attrs: {
                          name: "edit_assessment_section_title",
                          placeholder: "Enter Section Title...",
                          maxlength: "255"
                        },
                        domProps: { value: _vm.edit_assessment_section_title },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.edit_assessment_section_title =
                              $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule(
                        "edit_assessment_section_title",
                        "required"
                      )
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margin-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Assessment Section Title is required")]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-lg-3 float-left padding-lr-5" },
                    [
                      _c("b-form-select", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "input-text col-lg-12 padding-lr-5",
                        attrs: {
                          name: "edit_scale",
                          options: _vm.scale_options
                        },
                        model: {
                          value: _vm.edit_scale,
                          callback: function($$v) {
                            _vm.edit_scale = $$v
                          },
                          expression: "edit_scale"
                        }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule("edit_scale", "required")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margine-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Scale is required")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-lg-3 float-left padding-lr-5" },
                    [
                      _c("b-form-select", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "input-text col-lg-12 padding-lr-5",
                        attrs: {
                          name: "edit_section_type",
                          options: _vm.section_type_options
                        },
                        on: {
                          change: function($event) {
                            return _vm.editSectionRangeDisplay()
                          }
                        },
                        model: {
                          value: _vm.edit_section_type,
                          callback: function($$v) {
                            _vm.edit_section_type = $$v
                          },
                          expression: "edit_section_type"
                        }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule("edit_section_type", "required")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margin-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Type is required")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { clear: "both", "margin-bottom": "10px" }
                }),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "col-11 override-padding" }, [
                  _c("div", { staticClass: "heading-row" }, [
                    _c("div", { staticClass: "col-1 float-left" }, [
                      _vm._v("#")
                    ]),
                    _vm._v(" "),
                    _vm.edit_section_range_display == true
                      ? _c(
                          "div",
                          { staticClass: "col-2 float-left padding-lr-5" },
                          [_vm._v("Group")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-2 float-left padding-lr-5" },
                      [_vm._v("Type")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-7 float-left padding-lr-5" },
                      [_vm._v("Statement/Question Text")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-11 override-padding float-left",
                    staticStyle: { "margin-top": "10px" }
                  },
                  _vm._l(_vm.edit_statement_questions, function(list, sindex) {
                    return _c(
                      "div",
                      {
                        key: sindex,
                        staticClass:
                          "statement-row col-12 override-padding float-left",
                        staticStyle: { "margin-bottom": "5px" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "col-1 float-left",
                            staticStyle: {
                              "font-weight": "bold",
                              "margin-top": "5px"
                            }
                          },
                          [_vm._v(_vm._s(sindex + 1))]
                        ),
                        _vm._v(" "),
                        _vm.edit_section_range_display == true
                          ? _c(
                              "div",
                              { staticClass: "col-2 float-left padding-lr-5" },
                              [
                                _c("b-form-select", {
                                  ref: "group_" + sindex,
                                  refInFor: true,
                                  staticClass:
                                    "input-text col-lg-12 float-left padding-lr-5",
                                  attrs: { options: _vm.group_options },
                                  on: {
                                    change: function($event) {
                                      return _vm.captureModificaton(sindex)
                                    }
                                  },
                                  model: {
                                    value: list.group,
                                    callback: function($$v) {
                                      _vm.$set(list, "group", $$v)
                                    },
                                    expression: "list.group"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-2 float-left padding-lr-5" },
                          [
                            _c("b-form-select", {
                              ref: "type_" + sindex,
                              refInFor: true,
                              staticClass:
                                "input-text col-lg-12 float-left padding-lr-5",
                              attrs: { options: _vm.type_options },
                              on: {
                                change: function($event) {
                                  return _vm.captureModificaton(sindex)
                                }
                              },
                              model: {
                                value: list.type,
                                callback: function($$v) {
                                  _vm.$set(list, "type", $$v)
                                },
                                expression: "list.type"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-6 float-left padding-lr-5",
                            staticStyle: { "padding-right": "0" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: list.text,
                                  expression: "list.text"
                                }
                              ],
                              ref: "text_" + sindex,
                              refInFor: true,
                              staticClass:
                                "col-lg-12 input-text form-control float-left padding-lr-5",
                              staticStyle: { "line-height": "30px" },
                              attrs: {
                                placeholder: "Enter Statement/Question",
                                maxlength: "255"
                              },
                              domProps: { value: list.text },
                              on: {
                                change: function($event) {
                                  return _vm.captureModificaton(sindex)
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(list, "text", $event.target.value)
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _vm.edit_statement_questions.length > 1
                          ? _c(
                              "div",
                              {
                                staticClass: "col-1 float-left delete-icon",
                                staticStyle: {
                                  "font-weight": "bold",
                                  "margin-top": "5px"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa fa-window-close cursor-pointer",
                                  attrs: { "aria-hidden": "true" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeQuestions(sindex)
                                    }
                                  }
                                })
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { clear: "both", "margin-bottom": "5px" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-11 override-padding" }, [
                  _c(
                    "div",
                    { staticClass: "col-5 override-padding float-left" },
                    [_vm._v("\n             \n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-7 padding-lr-5 float-left add-on ",
                      on: {
                        click: function($event) {
                          return _vm.editAddMoreQuestions()
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-plus spacer-icon",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" Add Statement/Question (100 Max)\n          ")
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { clear: "both", "margin-bottom": "10px" }
                }),
                _vm._v(" "),
                _vm.edit_section_range_display == true
                  ? _c("div", { staticClass: "col-11 override-padding" }, [
                      _c("div", { staticClass: "add-statement-heading" }, [
                        _vm._v(
                          "\n            Enter Output Ranges and Text\n          "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("A"),
                        expression: "editCheckVisible('A')"
                      }
                    ],
                    staticClass: "col-11 override-padding collapse-wrapper"
                  },
                  [
                    _c(
                      "b-link",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle",
                            value: "collapse-A",
                            expression: "'collapse-A'"
                          }
                        ]
                      },
                      [
                        _c("div", [
                          _vm._v("\n              Group A\n              "),
                          _c("i", {
                            staticClass: "fa fa-angle-up",
                            attrs: { "aria-hidden": "true" }
                          })
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("A"),
                        expression: "editCheckVisible('A')"
                      }
                    ],
                    staticClass: "mt-2",
                    attrs: { id: "collapse-A", visible: "" }
                  },
                  [
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c("div", { staticClass: "heading-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("From")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-1 float-left padding-lr-5 text-align-center"
                          },
                          [_vm._v(">/<")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("To")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 float-left padding-lr-5" },
                          [_vm._v("Output Text")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-11 override-padding float-left",
                        staticStyle: { "margin-top": "10px" }
                      },
                      _vm._l(_vm.edit_group_a_range, function(list, aindex) {
                        return _c(
                          "div",
                          {
                            key: aindex,
                            staticClass:
                              "statement-row col-12 override-padding float-left",
                            staticStyle: { "margin-bottom": "5px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.from,
                                      expression: "list.from"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.from },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        aindex,
                                        "From",
                                        "A"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        list,
                                        "from",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-1 float-left padding-lr-5 text-align-center",
                                staticStyle: { "margin-top": "5px" }
                              },
                              [_vm._v("\n              -\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.to,
                                      expression: "list.to"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.to },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        aindex,
                                        "To",
                                        "A"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(list, "to", $event.target.value)
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-8 float-left padding-lr-5",
                                staticStyle: { "padding-right": "0" }
                              },
                              [
                                _c("vue-editor", {
                                  attrs: { editorToolbar: _vm.customToolbar },
                                  model: {
                                    value: list.text,
                                    callback: function($$v) {
                                      _vm.$set(list, "text", $$v)
                                    },
                                    expression: "list.text"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.edit_group_a_range.length > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-1 float-left delete-icon",
                                    staticStyle: {
                                      "font-weight": "bold",
                                      "margin-top": "5px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-window-close cursor-pointer",
                                      attrs: { "aria-hidden": "true" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeGroupRange(
                                            aindex,
                                            "A"
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { clear: "both", "margin-bottom": "5px" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c(
                        "div",
                        { staticClass: "col-3 override-padding float-left" },
                        [_vm._v("\n             \n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-9 padding-lr-5 float-left add-on",
                          on: {
                            click: function($event) {
                              return _vm.editAddMoreOutputText("A")
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-plus spacer-icon",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "font-style": "italic" } },
                            [_vm._v("Add Score Range (25 Max) ")]
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { clear: "both", "margin-bottom": "10px" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("B"),
                        expression: "editCheckVisible('B')"
                      }
                    ],
                    staticClass: "col-11 overridepadding collapse-wrapper"
                  },
                  [
                    _c(
                      "b-link",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle",
                            value: "collapse-B",
                            expression: "'collapse-B'"
                          }
                        ]
                      },
                      [
                        _c("div", [
                          _vm._v("\n              Group B\n              "),
                          _c("i", {
                            staticClass: "fa fa-angle-up",
                            attrs: { "aria-hidden": "true" }
                          })
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("B"),
                        expression: "editCheckVisible('B')"
                      }
                    ],
                    staticClass: "mt-2",
                    attrs: { id: "collapse-B", visible: "" }
                  },
                  [
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c("div", { staticClass: "heading-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("From")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-1 float-left padding-lr-5 text-align-center"
                          },
                          [_vm._v(">/<")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("To")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 float-left padding-lr-5" },
                          [_vm._v("Output Text")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-11 override-padding float-left",
                        staticStyle: { "margin-top": "10px" }
                      },
                      _vm._l(_vm.edit_group_b_range, function(list, bindex) {
                        return _c(
                          "div",
                          {
                            key: bindex,
                            staticClass:
                              "statement-row col-12 override-padding float-left",
                            staticStyle: { "margin-bottom": "5px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.from,
                                      expression: "list.from"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.from },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "From",
                                        "B"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        list,
                                        "from",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-1 float-left padding-lr-5 text-align-center",
                                staticStyle: { "margin-top": "5px" }
                              },
                              [_vm._v("\n              -\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.to,
                                      expression: "list.to"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.to },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "To",
                                        "B"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(list, "to", $event.target.value)
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-8 float-left padding-lr-5",
                                staticStyle: { "padding-right": "0" }
                              },
                              [
                                _c("vue-editor", {
                                  attrs: { editorToolbar: _vm.customToolbar },
                                  model: {
                                    value: list.text,
                                    callback: function($$v) {
                                      _vm.$set(list, "text", $$v)
                                    },
                                    expression: "list.text"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.edit_group_b_range.length > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-1 float-left delete-icon",
                                    staticStyle: {
                                      "font-weight": "bold",
                                      "margin-top": "5px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-window-close cursor-pointer",
                                      attrs: { "aria-hidden": "true" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeGroupRange(
                                            bindex,
                                            "B"
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { clear: "both", "margin-bottom": "5px" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c(
                        "div",
                        { staticClass: "col-3 override-padding float-left" },
                        [_vm._v("\n             \n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-9 padding-lr-5 float-left add-on",
                          on: {
                            click: function($event) {
                              return _vm.editAddMoreOutputText("B")
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-plus spacer-icon",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "font-style": "italic" } },
                            [_vm._v("Add Score Range (25 Max) ")]
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { clear: "both", "margin-bottom": "10px" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("C"),
                        expression: "editCheckVisible('C')"
                      }
                    ],
                    staticClass: "col-11 overridepadding collapse-wrapper"
                  },
                  [
                    _c(
                      "b-link",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle",
                            value: "collapse-C",
                            expression: "'collapse-C'"
                          }
                        ]
                      },
                      [
                        _c("div", [
                          _vm._v("\n              Group C\n              "),
                          _c("i", {
                            staticClass: "fa fa-angle-up",
                            attrs: { "aria-hidden": "true" }
                          })
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("C"),
                        expression: "editCheckVisible('C')"
                      }
                    ],
                    staticClass: "mt-2",
                    attrs: { id: "collapse-C", visible: "" }
                  },
                  [
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c("div", { staticClass: "heading-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("From")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-1 float-left padding-lr-5 text-align-center"
                          },
                          [_vm._v(">/<")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("To")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 float-left padding-lr-5" },
                          [_vm._v("Output Text")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-11 override-padding float-left",
                        staticStyle: { "margin-top": "10px" }
                      },
                      _vm._l(_vm.edit_group_c_range, function(list, bindex) {
                        return _c(
                          "div",
                          {
                            key: bindex,
                            staticClass:
                              "statement-row col-12 override-padding float-left",
                            staticStyle: { "margin-bottom": "5px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.from,
                                      expression: "list.from"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.from },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "From",
                                        "C"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        list,
                                        "from",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-1 float-left padding-lr-5 text-align-center",
                                staticStyle: { "margin-top": "5px" }
                              },
                              [_vm._v("\n              -\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.to,
                                      expression: "list.to"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.to },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "To",
                                        "C"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(list, "to", $event.target.value)
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-8 float-left padding-lr-5",
                                staticStyle: { "padding-right": "0" }
                              },
                              [
                                _c("vue-editor", {
                                  attrs: { editorToolbar: _vm.customToolbar },
                                  model: {
                                    value: list.text,
                                    callback: function($$v) {
                                      _vm.$set(list, "text", $$v)
                                    },
                                    expression: "list.text"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.edit_group_c_range.length > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-1 float-left delete-icon",
                                    staticStyle: {
                                      "font-weight": "bold",
                                      "margin-top": "5px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-window-close cursor-pointer",
                                      attrs: { "aria-hidden": "true" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeGroupRange(
                                            bindex,
                                            "C"
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { clear: "both", "margin-bottom": "5px" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c(
                        "div",
                        { staticClass: "col-3 override-padding float-left" },
                        [_vm._v("\n             \n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-9 padding-lr-5 float-left add-on",
                          on: {
                            click: function($event) {
                              return _vm.editAddMoreOutputText("C")
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-plus spacer-icon",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "font-style": "italic" } },
                            [_vm._v("Add Score Range (25 Max) ")]
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { clear: "both", "margin-bottom": "10px" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("D"),
                        expression: "editCheckVisible('D')"
                      }
                    ],
                    staticClass: "col-11 overridepadding collapse-wrapper"
                  },
                  [
                    _c(
                      "b-link",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle",
                            value: "collapse-D",
                            expression: "'collapse-D'"
                          }
                        ]
                      },
                      [
                        _c("div", [
                          _vm._v("\n              Group D\n              "),
                          _c("i", {
                            staticClass: "fa fa-angle-up",
                            attrs: { "aria-hidden": "true" }
                          })
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("D"),
                        expression: "editCheckVisible('D')"
                      }
                    ],
                    staticClass: "mt-2",
                    attrs: { id: "collapse-D", visible: "" }
                  },
                  [
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c("div", { staticClass: "heading-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("From")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-1 float-left padding-lr-5 text-align-center"
                          },
                          [_vm._v(">/<")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("To")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 float-left padding-lr-5" },
                          [_vm._v("Output Text")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-11 override-padding float-left",
                        staticStyle: { "margin-top": "10px" }
                      },
                      _vm._l(_vm.edit_group_d_range, function(list, bindex) {
                        return _c(
                          "div",
                          {
                            key: bindex,
                            staticClass:
                              "statement-row col-12 override-padding float-left",
                            staticStyle: { "margin-bottom": "5px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.from,
                                      expression: "list.from"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.from },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "From",
                                        "D"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        list,
                                        "from",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-1 float-left padding-lr-5 text-align-center",
                                staticStyle: { "margin-top": "5px" }
                              },
                              [_vm._v("\n              -\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.to,
                                      expression: "list.to"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.to },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "To",
                                        "D"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(list, "to", $event.target.value)
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-8 float-left padding-lr-5",
                                staticStyle: { "padding-right": "0" }
                              },
                              [
                                _c("vue-editor", {
                                  attrs: { editorToolbar: _vm.customToolbar },
                                  model: {
                                    value: list.text,
                                    callback: function($$v) {
                                      _vm.$set(list, "text", $$v)
                                    },
                                    expression: "list.text"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.edit_group_d_range.length > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-1 float-left delete-icon",
                                    staticStyle: {
                                      "font-weight": "bold",
                                      "margin-top": "5px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-window-close cursor-pointer",
                                      attrs: { "aria-hidden": "true" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeGroupRange(
                                            bindex,
                                            "D"
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { clear: "both", "margin-bottom": "5px" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c(
                        "div",
                        { staticClass: "col-3 override-padding float-left" },
                        [_vm._v("\n             \n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-9 padding-lr-5 float-left add-on",
                          on: {
                            click: function($event) {
                              return _vm.editAddMoreOutputText("D")
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-plus spacer-icon",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "font-style": "italic" } },
                            [_vm._v("Add Score Range (25 Max) ")]
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { clear: "both", "margin-bottom": "10px" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("E"),
                        expression: "editCheckVisible('E')"
                      }
                    ],
                    staticClass: "col-11 overridepadding collapse-wrapper"
                  },
                  [
                    _c(
                      "b-link",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle",
                            value: "collapse-E",
                            expression: "'collapse-E'"
                          }
                        ]
                      },
                      [
                        _c("div", [
                          _vm._v("\n              Group E\n              "),
                          _c("i", {
                            staticClass: "fa fa-angle-up",
                            attrs: { "aria-hidden": "true" }
                          })
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("E"),
                        expression: "editCheckVisible('E')"
                      }
                    ],
                    staticClass: "mt-2",
                    attrs: { id: "collapse-E", visible: "" }
                  },
                  [
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c("div", { staticClass: "heading-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("From")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-1 float-left padding-lr-5 text-align-center"
                          },
                          [_vm._v(">/<")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("To")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 float-left padding-lr-5" },
                          [_vm._v("Output Text")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-11 override-padding float-left",
                        staticStyle: { "margin-top": "10px" }
                      },
                      _vm._l(_vm.edit_group_e_range, function(list, bindex) {
                        return _c(
                          "div",
                          {
                            key: bindex,
                            staticClass:
                              "statement-row col-12 override-padding float-left",
                            staticStyle: { "margin-bottom": "5px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.from,
                                      expression: "list.from"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.from },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "From",
                                        "E"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        list,
                                        "from",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-1 float-left padding-lr-5 text-align-center",
                                staticStyle: { "margin-top": "5px" }
                              },
                              [_vm._v("\n              -\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.to,
                                      expression: "list.to"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.to },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "To",
                                        "E"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(list, "to", $event.target.value)
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-8 float-left padding-lr-5",
                                staticStyle: { "padding-right": "0" }
                              },
                              [
                                _c("vue-editor", {
                                  attrs: { editorToolbar: _vm.customToolbar },
                                  model: {
                                    value: list.text,
                                    callback: function($$v) {
                                      _vm.$set(list, "text", $$v)
                                    },
                                    expression: "list.text"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.edit_group_e_range.length > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-1 float-left delete-icon",
                                    staticStyle: {
                                      "font-weight": "bold",
                                      "margin-top": "5px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-window-close cursor-pointer",
                                      attrs: { "aria-hidden": "true" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeGroupRange(
                                            bindex,
                                            "E"
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { clear: "both", "margin-bottom": "5px" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c(
                        "div",
                        { staticClass: "col-3 override-padding float-left" },
                        [_vm._v("\n             \n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-9 padding-lr-5 float-left add-on",
                          on: {
                            click: function($event) {
                              return _vm.editAddMoreOutputText("E")
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-plus spacer-icon",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "font-style": "italic" } },
                            [_vm._v("Add Score Range (25 Max) ")]
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { clear: "both", "margin-bottom": "10px" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("F"),
                        expression: "editCheckVisible('F')"
                      }
                    ],
                    staticClass: "col-11 overridepadding collapse-wrapper"
                  },
                  [
                    _c(
                      "b-link",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle",
                            value: "collapse-F",
                            expression: "'collapse-F'"
                          }
                        ]
                      },
                      [
                        _c("div", [
                          _vm._v("\n              Group F\n              "),
                          _c("i", {
                            staticClass: "fa fa-angle-up",
                            attrs: { "aria-hidden": "true" }
                          })
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("F"),
                        expression: "editCheckVisible('F')"
                      }
                    ],
                    staticClass: "mt-2",
                    attrs: { id: "collapse-F", visible: "" }
                  },
                  [
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c("div", { staticClass: "heading-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("From")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-1 float-left padding-lr-5 text-align-center"
                          },
                          [_vm._v(">/<")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("To")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 float-left padding-lr-5" },
                          [_vm._v("Output Text")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-11 override-padding float-left",
                        staticStyle: { "margin-top": "10px" }
                      },
                      _vm._l(_vm.edit_group_f_range, function(list, bindex) {
                        return _c(
                          "div",
                          {
                            key: bindex,
                            staticClass:
                              "statement-row col-12 override-padding float-left",
                            staticStyle: { "margin-bottom": "5px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.from,
                                      expression: "list.from"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.from },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "From",
                                        "F"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        list,
                                        "from",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-1 float-left padding-lr-5 text-align-center",
                                staticStyle: { "margin-top": "5px" }
                              },
                              [_vm._v("\n              -\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.to,
                                      expression: "list.to"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.to },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "To",
                                        "F"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(list, "to", $event.target.value)
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-8 float-left padding-lr-5",
                                staticStyle: { "padding-right": "0" }
                              },
                              [
                                _c("vue-editor", {
                                  attrs: { editorToolbar: _vm.customToolbar },
                                  model: {
                                    value: list.text,
                                    callback: function($$v) {
                                      _vm.$set(list, "text", $$v)
                                    },
                                    expression: "list.text"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.edit_group_f_range.length > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-1 float-left delete-icon",
                                    staticStyle: {
                                      "font-weight": "bold",
                                      "margin-top": "5px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-window-close cursor-pointer",
                                      attrs: { "aria-hidden": "true" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeGroupRange(
                                            bindex,
                                            "F"
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { clear: "both", "margin-bottom": "5px" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c(
                        "div",
                        { staticClass: "col-3 override-padding float-left" },
                        [_vm._v("\n             \n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-9 padding-lr-5 float-left add-on",
                          on: {
                            click: function($event) {
                              return _vm.editAddMoreOutputText("F")
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-plus spacer-icon",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "font-style": "italic" } },
                            [_vm._v("Add Score Range (25 Max) ")]
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { clear: "both", "margin-bottom": "10px" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("G"),
                        expression: "editCheckVisible('G')"
                      }
                    ],
                    staticClass: "col-11 overridepadding collapse-wrapper"
                  },
                  [
                    _c(
                      "b-link",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle",
                            value: "collapse-G",
                            expression: "'collapse-G'"
                          }
                        ]
                      },
                      [
                        _c("div", [
                          _vm._v("\n              Group G\n              "),
                          _c("i", {
                            staticClass: "fa fa-angle-up",
                            attrs: { "aria-hidden": "true" }
                          })
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("G"),
                        expression: "editCheckVisible('G')"
                      }
                    ],
                    staticClass: "mt-2",
                    attrs: { id: "collapse-G", visible: "" }
                  },
                  [
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c("div", { staticClass: "heading-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("From")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-1 float-left padding-lr-5 text-align-center"
                          },
                          [_vm._v(">/<")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("To")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 float-left padding-lr-5" },
                          [_vm._v("Output Text")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-11 override-padding float-left",
                        staticStyle: { "margin-top": "10px" }
                      },
                      _vm._l(_vm.edit_group_g_range, function(list, bindex) {
                        return _c(
                          "div",
                          {
                            key: bindex,
                            staticClass:
                              "statement-row col-12 override-padding float-left",
                            staticStyle: { "margin-bottom": "5px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.from,
                                      expression: "list.from"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.from },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "From",
                                        "G"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        list,
                                        "from",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-1 float-left padding-lr-5 text-align-center",
                                staticStyle: { "margin-top": "5px" }
                              },
                              [_vm._v("\n              -\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.to,
                                      expression: "list.to"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.to },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "To",
                                        "G"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(list, "to", $event.target.value)
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-8 float-left padding-lr-5",
                                staticStyle: { "padding-right": "0" }
                              },
                              [
                                _c("vue-editor", {
                                  attrs: { editorToolbar: _vm.customToolbar },
                                  model: {
                                    value: list.text,
                                    callback: function($$v) {
                                      _vm.$set(list, "text", $$v)
                                    },
                                    expression: "list.text"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.edit_group_g_range.length > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-1 float-left delete-icon",
                                    staticStyle: {
                                      "font-weight": "bold",
                                      "margin-top": "5px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-window-close cursor-pointer",
                                      attrs: { "aria-hidden": "true" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeGroupRange(
                                            bindex,
                                            "G"
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { clear: "both", "margin-bottom": "5px" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c(
                        "div",
                        { staticClass: "col-3 override-padding float-left" },
                        [_vm._v("\n             \n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-9 padding-lr-5 float-left add-on",
                          on: {
                            click: function($event) {
                              return _vm.editAddMoreOutputText("G")
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-plus spacer-icon",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "font-style": "italic" } },
                            [_vm._v("Add Score Range (25 Max) ")]
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { clear: "both", "margin-bottom": "10px" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("H"),
                        expression: "editCheckVisible('H')"
                      }
                    ],
                    staticClass: "col-11 overridepadding collapse-wrapper"
                  },
                  [
                    _c(
                      "b-link",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle",
                            value: "collapse-H",
                            expression: "'collapse-H'"
                          }
                        ]
                      },
                      [
                        _c("div", [
                          _vm._v("\n              Group H\n              "),
                          _c("i", {
                            staticClass: "fa fa-angle-up",
                            attrs: { "aria-hidden": "true" }
                          })
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("H"),
                        expression: "editCheckVisible('H')"
                      }
                    ],
                    staticClass: "mt-2",
                    attrs: { id: "collapse-H", visible: "" }
                  },
                  [
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c("div", { staticClass: "heading-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("From")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-1 float-left padding-lr-5 text-align-center"
                          },
                          [_vm._v(">/<")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("To")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 float-left padding-lr-5" },
                          [_vm._v("Output Text")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-11 override-padding float-left",
                        staticStyle: { "margin-top": "10px" }
                      },
                      _vm._l(_vm.edit_group_h_range, function(list, bindex) {
                        return _c(
                          "div",
                          {
                            key: bindex,
                            staticClass:
                              "statement-row col-12 override-padding float-left",
                            staticStyle: { "margin-bottom": "5px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.from,
                                      expression: "list.from"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.from },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "From",
                                        "H"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        list,
                                        "from",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-1 float-left padding-lr-5 text-align-center",
                                staticStyle: { "margin-top": "5px" }
                              },
                              [_vm._v("\n              -\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.to,
                                      expression: "list.to"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.to },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "To",
                                        "H"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(list, "to", $event.target.value)
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-8 float-left padding-lr-5",
                                staticStyle: { "padding-right": "0" }
                              },
                              [
                                _c("vue-editor", {
                                  attrs: { editorToolbar: _vm.customToolbar },
                                  model: {
                                    value: list.text,
                                    callback: function($$v) {
                                      _vm.$set(list, "text", $$v)
                                    },
                                    expression: "list.text"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.edit_group_h_range.length > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-1 float-left delete-icon",
                                    staticStyle: {
                                      "font-weight": "bold",
                                      "margin-top": "5px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-window-close cursor-pointer",
                                      attrs: { "aria-hidden": "true" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeGroupRange(
                                            bindex,
                                            "H"
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { clear: "both", "margin-bottom": "5px" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c(
                        "div",
                        { staticClass: "col-3 override-padding float-left" },
                        [_vm._v("\n             \n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-9 padding-lr-5 float-left add-on",
                          on: {
                            click: function($event) {
                              return _vm.editAddMoreOutputText("H")
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-plus spacer-icon",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "font-style": "italic" } },
                            [_vm._v("Add Score Range (25 Max) ")]
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { clear: "both", "margin-bottom": "10px" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("I"),
                        expression: "editCheckVisible('I')"
                      }
                    ],
                    staticClass: "col-11 overridepadding collapse-wrapper"
                  },
                  [
                    _c(
                      "b-link",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle",
                            value: "collapse-I",
                            expression: "'collapse-I'"
                          }
                        ]
                      },
                      [
                        _c("div", [
                          _vm._v("\n              Group I\n              "),
                          _c("i", {
                            staticClass: "fa fa-angle-up",
                            attrs: { "aria-hidden": "true" }
                          })
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("I"),
                        expression: "editCheckVisible('I')"
                      }
                    ],
                    staticClass: "mt-2",
                    attrs: { id: "collapse-I", visible: "" }
                  },
                  [
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c("div", { staticClass: "heading-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("From")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-1 float-left padding-lr-5 text-align-center"
                          },
                          [_vm._v(">/<")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("To")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 float-left padding-lr-5" },
                          [_vm._v("Output Text")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-11 override-padding float-left",
                        staticStyle: { "margin-top": "10px" }
                      },
                      _vm._l(_vm.edit_group_i_range, function(list, bindex) {
                        return _c(
                          "div",
                          {
                            key: bindex,
                            staticClass:
                              "statement-row col-12 override-padding float-left",
                            staticStyle: { "margin-bottom": "5px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.from,
                                      expression: "list.from"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.from },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "From",
                                        "I"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        list,
                                        "from",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-1 float-left padding-lr-5 text-align-center",
                                staticStyle: { "margin-top": "5px" }
                              },
                              [_vm._v("\n              -\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.to,
                                      expression: "list.to"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.to },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "To",
                                        "I"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(list, "to", $event.target.value)
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-8 float-left padding-lr-5",
                                staticStyle: { "padding-right": "0" }
                              },
                              [
                                _c("vue-editor", {
                                  attrs: { editorToolbar: _vm.customToolbar },
                                  model: {
                                    value: list.text,
                                    callback: function($$v) {
                                      _vm.$set(list, "text", $$v)
                                    },
                                    expression: "list.text"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.edit_group_i_range.length > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-1 float-left delete-icon",
                                    staticStyle: {
                                      "font-weight": "bold",
                                      "margin-top": "5px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-window-close cursor-pointer",
                                      attrs: { "aria-hidden": "true" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeGroupRange(
                                            bindex,
                                            "I"
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { clear: "both", "margin-bottom": "5px" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c(
                        "div",
                        { staticClass: "col-3 override-padding float-left" },
                        [_vm._v("\n             \n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-9 padding-lr-5 float-left add-on",
                          on: {
                            click: function($event) {
                              return _vm.editAddMoreOutputText("I")
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-plus spacer-icon",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "font-style": "italic" } },
                            [_vm._v("Add Score Range (25 Max) ")]
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { clear: "both", "margin-bottom": "10px" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("J"),
                        expression: "editCheckVisible('J')"
                      }
                    ],
                    staticClass: "col-11 overridepadding collapse-wrapper"
                  },
                  [
                    _c(
                      "b-link",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle",
                            value: "collapse-J",
                            expression: "'collapse-J'"
                          }
                        ]
                      },
                      [
                        _c("div", [
                          _vm._v("\n              Group J\n              "),
                          _c("i", {
                            staticClass: "fa fa-angle-up",
                            attrs: { "aria-hidden": "true" }
                          })
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("J"),
                        expression: "editCheckVisible('J')"
                      }
                    ],
                    staticClass: "mt-2",
                    attrs: { id: "collapse-J", visible: "" }
                  },
                  [
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c("div", { staticClass: "heading-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("From")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-1 float-left padding-lr-5 text-align-center"
                          },
                          [_vm._v(">/<")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("To")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 float-left padding-lr-5" },
                          [_vm._v("Output Text")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-11 override-padding float-left",
                        staticStyle: { "margin-top": "10px" }
                      },
                      _vm._l(_vm.edit_group_j_range, function(list, bindex) {
                        return _c(
                          "div",
                          {
                            key: bindex,
                            staticClass:
                              "statement-row col-12 override-padding float-left",
                            staticStyle: { "margin-bottom": "5px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.from,
                                      expression: "list.from"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.from },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "From",
                                        "J"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        list,
                                        "from",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-1 float-left padding-lr-5 text-align-center",
                                staticStyle: { "margin-top": "5px" }
                              },
                              [_vm._v("\n              -\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.to,
                                      expression: "list.to"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.to },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "To",
                                        "J"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(list, "to", $event.target.value)
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-8 float-left padding-lr-5",
                                staticStyle: { "padding-right": "0" }
                              },
                              [
                                _c("vue-editor", {
                                  attrs: { editorToolbar: _vm.customToolbar },
                                  model: {
                                    value: list.text,
                                    callback: function($$v) {
                                      _vm.$set(list, "text", $$v)
                                    },
                                    expression: "list.text"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.edit_group_j_range.length > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-1 float-left delete-icon",
                                    staticStyle: {
                                      "font-weight": "bold",
                                      "margin-top": "5px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-window-close cursor-pointer",
                                      attrs: { "aria-hidden": "true" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeGroupRange(
                                            bindex,
                                            "J"
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { clear: "both", "margin-bottom": "5px" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c(
                        "div",
                        { staticClass: "col-3 override-padding float-left" },
                        [_vm._v("\n             \n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-9 padding-lr-5 float-left add-on",
                          on: {
                            click: function($event) {
                              return _vm.editAddMoreOutputText("J")
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-plus spacer-icon",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "font-style": "italic" } },
                            [_vm._v("Add Score Range (25 Max) ")]
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { clear: "both", "margin-bottom": "10px" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("K"),
                        expression: "editCheckVisible('K')"
                      }
                    ],
                    staticClass: "col-11 overridepadding collapse-wrapper"
                  },
                  [
                    _c(
                      "b-link",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle",
                            value: "collapse-K",
                            expression: "'collapse-K'"
                          }
                        ]
                      },
                      [
                        _c("div", [
                          _vm._v("\n              Group K\n              "),
                          _c("i", {
                            staticClass: "fa fa-angle-up",
                            attrs: { "aria-hidden": "true" }
                          })
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editCheckVisible("K"),
                        expression: "editCheckVisible('K')"
                      }
                    ],
                    staticClass: "mt-2",
                    attrs: { id: "collapse-K", visible: "" }
                  },
                  [
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c("div", { staticClass: "heading-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("From")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-1 float-left padding-lr-5 text-align-center"
                          },
                          [_vm._v(">/<")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-1 float-left padding-lr-5" },
                          [_vm._v("To")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 float-left padding-lr-5" },
                          [_vm._v("Output Text")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-11 override-padding float-left",
                        staticStyle: { "margin-top": "10px" }
                      },
                      _vm._l(_vm.edit_group_k_range, function(list, bindex) {
                        return _c(
                          "div",
                          {
                            key: bindex,
                            staticClass:
                              "statement-row col-12 override-padding float-left",
                            staticStyle: { "margin-bottom": "5px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.from,
                                      expression: "list.from"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.from },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "From",
                                        "K"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        list,
                                        "from",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-1 float-left padding-lr-5 text-align-center",
                                staticStyle: { "margin-top": "5px" }
                              },
                              [_vm._v("\n              -\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-1 float-left padding-lr-5" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: list.to,
                                      expression: "list.to"
                                    }
                                  ],
                                  staticClass:
                                    "col-lg-12 input-text form-control float-left padding-lr-5",
                                  staticStyle: { "line-height": "30px" },
                                  attrs: { maxlength: "5" },
                                  domProps: { value: list.to },
                                  on: {
                                    blur: function($event) {
                                      return _vm.editCheckRangeNumbers(
                                        bindex,
                                        "To",
                                        "K"
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(list, "to", $event.target.value)
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-8 float-left padding-lr-5",
                                staticStyle: { "padding-right": "0" }
                              },
                              [
                                _c("vue-editor", {
                                  attrs: { editorToolbar: _vm.customToolbar },
                                  model: {
                                    value: list.text,
                                    callback: function($$v) {
                                      _vm.$set(list, "text", $$v)
                                    },
                                    expression: "list.text"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.edit_group_k_range.length > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col-1 float-left delete-icon",
                                    staticStyle: {
                                      "font-weight": "bold",
                                      "margin-top": "5px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-window-close cursor-pointer",
                                      attrs: { "aria-hidden": "true" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeGroupRange(
                                            bindex,
                                            "K"
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { clear: "both", "margin-bottom": "5px" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c(
                        "div",
                        { staticClass: "col-3 override-padding float-left" },
                        [_vm._v("\n             \n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-9 padding-lr-5 float-left add-on",
                          on: {
                            click: function($event) {
                              return _vm.editAddMoreOutputText("K")
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-plus spacer-icon",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "font-style": "italic" } },
                            [_vm._v("Add Score Range (25 Max) ")]
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { clear: "both", "margin-bottom": "10px" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-11 override-padding" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-lg-2 col-md-4 col-4 padding-lr-5 float-right",
                      staticStyle: { "padding-right": "0px" }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-red col-12 override-padding",
                          staticStyle: {
                            "margin-top": "2px",
                            height: "32px",
                            "border-radius": "10px"
                          },
                          on: {
                            click: function($event) {
                              return _vm.editAssessmentSection()
                            }
                          }
                        },
                        [_vm._v("Update")]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { clear: "both", "margin-bottom": "15px" }
                }),
                _vm._v(" "),
                _c("hr", { staticClass: "custom_hr" }),
                _vm._v(" "),
                _c("div", { staticClass: "reps_history_label" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:void(0);" },
                      on: { click: _vm.showSectionHistory }
                    },
                    [
                      _vm._v("\n            Assessment Audit Trail "),
                      _c("i", {
                        class: _vm.toggleFontIcon,
                        staticStyle: { "font-size": "18px" }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("SectionHistory", {
                  ref: "section_history",
                  attrs: { sectionId: _vm.sectionId }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" })
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sub-heading" }, [
      _c("h3", [_vm._v("Edit Assessment Section")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-11 override-padding" }, [
      _c("div", { staticClass: "add-statement-heading" }, [
        _vm._v("\n            Add Statements/Questions\n          ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f37beea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f37beea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/edit_assessment_section_modal.vue
// module id = null
// module chunks = 